import { render, staticRenderFns } from "./wedding_suborder.vue?vue&type=template&id=6b70db7c&"
import script from "./wedding_suborder.vue?vue&type=script&lang=js&"
export * from "./wedding_suborder.vue?vue&type=script&lang=js&"
import style0 from "./wedding_suborder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports